import React, { useState } from "react";
import {
    Box,
    Container,
    Divider,
    Grid,
    Typography,
    useMediaQuery,
} from "@mui/material";
import FooterExtension from "./FooterExtension";
import CookieBar from "./CookieBar";
import { fontLink, footer_navigation, fullCenter, useMobile, useTablet } from "../../../base";
import LangLink from "../../../Localization/LangLink";
import { ReactComponent as XSite } from './social/icon_socials_x.svg';
import { ReactComponent as Facebook } from './social/icon_socials_fbk.svg';
import { ReactComponent as Linked } from './social/icon_socials_link.svg';
import { Motion } from "../../Motion";
import { Link } from "react-router-dom";
import LanguageMenu from "../AppBar/LanguageMenu";
import { Txt } from "../../../Routes/Localized";
import { useMobileMenu } from "../../MobileBar/MobileMenuProvider";
import { FOOTER_COLOR } from "./base";
import FooterCars from "./FooterCars";

const socials = [
    { name: 'X', link: 'https://x.com/Metastream_sro', svg: XSite },
    { name: 'Facebook', link: 'https://www.facebook.com/profile.php?id=100080042408340', svg: Facebook },
    { name: 'LinkedIn', link: 'https://cz.linkedin.com/in/metastream-s-r-o-577b98382', svg: Linked },
]

// buyExtension footerExtension
function BaseFooter({ ...props }) {
    const mobile = useMobile();
    const tablet = useTablet();
    const [cookieOpen, setCookieOpen] = useState(false);
    const { footerExtension = true, carsExtension = true, target = "_self" } = props;
    const { languageMenuMobileProps, isMobileBar } = useMobileMenu();

    return (
        <footer>

            <Container maxWidth='xl' sx={{
                ...(mobile && {
                    px: '0px !important'
                }),
            }}>
                {footerExtension && <FooterExtension {...props} />}
                {carsExtension && <FooterCars />}
                <Box
                    sx={{

                        width: "100%",
                        //height: `${220}px`,
                        bgcolor: FOOTER_COLOR,
                        position: "static",
                        bottom: 0,
                        pt: '32px',
                        ...(!footerExtension && { boxShadow: "0px -2px 5px 0px rgba(115,117,122,0.3)", borderTopLeftRadius: '20px', borderTopRightRadius: '20px', pt: '32px' }),
                    }}
                >
                    <Container
                        maxWidth="lg"
                        sx={{
                            pr: "0px !important",
                            bgcolor: FOOTER_COLOR,
                            pb: '24px'
                        }}
                    >
                        <Box sx={{ ...fullCenter, flexDirection: tablet ? 'column' : 'row', flexWrap: 'wrap', gap: tablet ? '12px' : '30px' }}>
                            <Box sx={{
                                ...fullCenter, flexDirection: 'row', flexWrap: 'wrap', gap: tablet ? '12px' : '30px',
                                ...(tablet && {})
                            }}>
                                {footer_navigation.map((n, i) => (
                                    <Box key={"BaseF" + i} sx={{
                                        ...(tablet && { flex: '0 0 calc(50% - 15px)' })
                                    }}>
                                        <Box component={LangLink} to={n.link} target={target} sx={{
                                            mb: "2px",
                                            textDecoration: 'none', width: 'fit-content'
                                        }}>
                                            <Typography
                                                sx={{
                                                    textAlign: "left",
                                                    ...(tablet && i % 2 === 0 && { textAlign: 'right' }),
                                                    textWrap: 'nowrap',
                                                    fontWeight: 400,
                                                    ...fontLink,
                                                    color: '#fff',
                                                }}
                                            >
                                                {n.title}
                                            </Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                            <LanguageMenu footer={true} {...(isMobileBar ? languageMenuMobileProps : {})} />
                        </Box>
                        <Box sx={{ ...fullCenter, flexDirection: 'row', width: '100%', gap: '16px', pb: '20px', pt: tablet ? '30px' : '40px' }}>
                            {socials.map((s, i) => {
                                const SvgImg = s.svg;
                                return <Motion key={"Motion" + s.name}>
                                    <Box component={Link} to={s.link} target="_blank" key={s.name} sx={{ width: '50px', height: '50px' }}>
                                        <SvgImg style={{ display: 'block' }} />
                                    </Box>
                                </Motion>
                            }
                            )}
                        </Box>
                        <Box sx={{ width: '100%', ...fullCenter, py: '24px' }}>
                            <Typography
                                sx={{
                                    textAlign: "center",
                                    fontWeight: 400,
                                    ...fontLink,
                                    color: 'white',
                                    maxWidth: '270px',
                                }}
                            >
                                <Txt id={"23038"} value={new Date().getFullYear()} />
                            </Typography>
                        </Box>
                    </Container>
                </Box>
            </Container>
        </footer>
    );
}

export default BaseFooter;
